import { useCallback, useMemo, useState } from 'react';

import debounce from 'lodash.debounce';

import { useBrowserEventListener } from '@sg/garnish';

export const useUsableNetScrolling = (params: Params = {}) => {
  const { skip = false } = params;

  const [isScrolled, setIsScrolled] = useState(false);

  const onScroll = useCallback((event: Event) => {
    const targetNode = event.target as unknown as { scrollTop: number };

    setIsScrolled(targetNode.scrollTop > 0);
  }, []);

  const debouncedOnScroll = useMemo(
    () => debounce(onScroll, 100, { leading: true, trailing: true }),
    [onScroll],
  );

  useBrowserEventListener(window, 'scroll', debouncedOnScroll, true, skip);

  return { isScrolled: skip ? false : isScrolled };
};

// ─── Types ───────────────────────────────────────────────────────────────────

type Params = { skip?: boolean };
